// All static rate elements can be found here - https://lite.coned.com/_external/cerates/elec.asp
const sharedConEdStaticRateElements = [
  {
    // ./docs/april-2025-rate-update/2025-clean-energy-demand-surcharge.pdf
    rateElementType: 'MonthlyEnergy',
    name: 'Clean Energy Standard Delivery Surcharge ("CESD")',
    billingCategory: 'delivery',
    rateComponents: [
      {
        charge: 0.000289,
        name: 'Clean Energy Standard Delivery Surcharge ("CESD")',
      },
    ],
  },
  // ./docs/april-2025-rate-update/2025-clean-energy-supply-surcharge.pdf
  {
    rateElementType: 'MonthlyEnergy',
    name: 'Clean Energy Standard Supply Surcharge',
    billingCategory: 'supply',
    rateComponents: [
      {
        charge: 0.00302,
        name: 'Clean Energy Standard Supply Surcharge',
      },
    ],
  },
  // ./docs/april-2025-rate-update/mac-adjustment-factor.pdf
  {
    rateElementType: 'MonthlyEnergy',
    name: 'MAC Adjustment Factor',
    billingCategory: 'delivery',
    rateComponents: [
      {
        charge: -0.006367,
        name: 'MAC Adjustment Factor',
      },
    ],
  },
  // ./docs/april-2025-rate-update/april-2025-merchant-function-charge.pdf
  {
    rateElementType: 'MonthlyEnergy',
    name: 'Merchant Function Charge',
    billingCategory: 'supply',
    rateComponents: [
      {
        charge: 0.001408,
        name: 'Merchant Function Charge',
      },
    ],
  },
  // ./docs/april-2025-rate-update/april-2025-montly-adjustment-clause.pdf
  {
    rateElementType: 'MonthlyEnergy',
    name: 'Monthly Adjustment Clause ("MAC")',
    billingCategory: 'delivery',
    rateComponents: [
      {
        charge: 0.0084,
        name: 'Monthly Adjustment Clause ("MAC")',
      },
    ],
  },
  // https://lite.coned.com/_external/cerates/elec_RDM_PSC10.asp
  // ./docs/april-2025-rate-update/feb-2025-revenue-decoupling.pdf
  {
    rateElementType: 'MonthlyEnergy',
    name: 'Revenue Decoupling Mechanism ("RDM")',
    billingCategory: 'delivery',
    rateComponents: [
      {
        charge: -0.00231,
        name: 'Revenue Decoupling Mechanism ("RDM")',
      },
    ],
  },
  // https://lite.coned.com/_external/cerates/elec_sbc_PSC10.asp
  // ./docs/april-2025-rate-update/jan-2025-system-benefit.pdf
  {
    rateElementType: 'MonthlyEnergy',
    name: 'System Benefit Charge ("SBC")',
    billingCategory: 'delivery',
    rateComponents: [
      {
        charge: 0.0066,
        name: 'System Benefit Charge ("SBC")',
      },
    ],
  },
  // ./docs/april-2025-rate-update/tax-sur-credit.pdf
  {
    rateElementType: 'MonthlyEnergy',
    name: 'Tax Sur-Credit',
    billingCategory: 'delivery',
    rateComponents: [
      {
        charge: 0.0,
        name: 'Tax Sur-Credit',
      },
    ],
  },
];

export default sharedConEdStaticRateElements;
